import { Component } from '@angular/core';
import { AngularFire } from 'angularfire2';

import { Home } from '../home/home';
import { Articles } from '../articles/articles';
import { Users } from '../users/users';
import { Posts } from '../posts/posts';
import { Settings } from '../settings/settings';

@Component({
  templateUrl: 'tabs.html'
})
export class Tabs {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  tab1Root: any = Home;
  tab2Root: any = Articles;
  tab3Root: any = Users;
  tab4Root: any = Posts;
  tab5Root: any = Settings;

  control: boolean = false;

  constructor(public af: AngularFire) {
    this.af.auth.subscribe( (authData) => {
      if (authData) {
        this.control = authData.uid === '' ? false : true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts